import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import Axios from 'axios'
import iView from 'view-design'
import config from '@/config'
import './index.less'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import 'view-design/dist/styles/iview.css'
import './assets/icons/iconfont.css'

import lottie from 'vue-lottie'
Vue.component('lottie', lottie)

// import { rightButtonShow, authButton, resubmitNotButton } from './utils/button'
import { authButton, resubmitNotButton } from './utils/button'
// import vueSwiper from 'vue-awesome-swiper'

// import 'swiper/swiper-bundle.css'
// 按钮等公共的样式
import './assets/basecss/index.css'
// 引入富文本
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import moment from 'moment'

// 引入放大图片组件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import importFilter from '@/filters/index.js'
Vue.use(Viewer)
Viewer.setDefaults({
  navbar: false, // 底部缩略图
  toolbar: true, // 底部工具栏
  button: false, // 右上角按钮
  title: false, // 当前图片标题
  movable: true, // 是否可以移动
  zoomable: true, // 是否可以缩放
  transition: false // 使用 CSS3 过度
})

// 引入bus
import VueBus from 'vue-bus'
Vue.use(VueBus)

import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en', // 默认语言
  fallbackLocale: 'en', // 如果当前语言翻译不存在，回退到的语言
  messages: {
    en: require('./language/en.js'),
    ch: require('./language/ch.js'),
    // 更多语言...
  },
});

Vue.use(VueQuillEditor)
Vue.use(iView)
Vue.use(VXETable)
// Vue.use(authButton)

Vue.use(resubmitNotButton) //防止按钮重复点击1000ms内，也可以自设时间
Vue.use(authButton) //全局方法判断当前角色按钮的使用权
// Vue.prototype.$ButtonShow = rightButtonShow

Vue.prototype.ajaxAll = Axios

Vue.config.productionTip = false

/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
// Vue.prototype.$Message.config({
//   top: 100,
//   duration: 1.5
// })

// // ie
// if (!Array.prototype.find) {
//   Array.prototype.find = function(callback) {
//     return callback && (this.filter(callback) || [])[0]
//   }
// }
VXETable.setup({
  version: 0,
  zIndex: 999999 // 想多高就设置多高
  // table: {
  //   autoResize: false
  // } 暂时不知道有什么用的
})
//解决DATE时间类型默认时区问题
Date.prototype.toISOString = function() {
  return moment(this).format('YYYY-MM-DD HH:mm:ss')
}
// 这个是解决销价级别的启用与禁用
Vue.prototype.$moment = moment //赋值使用

importFilter(Vue)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
